<div class="toast-stack" aria-live="polite" aria-relevant="additions">
  <article
    *ngFor="let t of toasts(); trackBy: trackById; let i = index"
    class="toast"
    [style.--stack-offset]="i"
    [style.--stack-total]="toasts().length"
    [class.is-paused]="t.paused"
    role="alert"
    tabindex="0"
    (mouseenter)="onMouseEnter(t.id)"
    (mouseleave)="onMouseLeave(t.id)"
    (click)="open(t)"
    (keydown.enter)="open(t)">

    <!-- Glow detras siguiendo el color del remitente. -->
    <div class="toast-glow" [style.background]="'radial-gradient(circle, ' + t.avatarColor + '33 0%, transparent 70%)'"></div>

    <div class="toast-avatar"
         [style.background-color]="t.avatarColor"
         [attr.aria-hidden]="true">
      <span>{{ t.avatarIniciales }}</span>
    </div>

    <div class="toast-body">
      <header class="toast-header">
        <span class="toast-name">{{ t.remitenteNombre }}</span>
        <span class="toast-meta">{{ formatRelative(t.enviadoEn) }}</span>
      </header>
      <p class="toast-preview">{{ t.preview }}</p>
      <div class="toast-cta-hint">
        <i class="dx-icon dx-icon-arrowright"></i>
        <span>Abrir conversación</span>
      </div>
    </div>

    <button
      type="button"
      class="toast-close"
      (click)="$event.stopPropagation(); dismiss(t.id)"
      [attr.aria-label]="'Cerrar notificación de ' + t.remitenteNombre">
      <i class="dx-icon dx-icon-close"></i>
    </button>

    <div class="toast-progress">
      <div class="toast-progress-bar" [style.width.%]="100 - progress(t)"></div>
    </div>
  </article>
</div>
